module.exports = __webpack_public_path__ + "static/media/StopChequePayment.239abce7.svg";